import SweetAlert from "react-bootstrap-sweetalert";
import { Button, Card, Container, Row, Col } from "react-bootstrap";
import React, { useEffect, useCallback, useMemo } from "react";
import { fetchStatus, statusDeleted,statusChangerEtat } from "../../../Redux/statusReduce";
import { useDispatch } from "react-redux";
import { verification } from "../../../Redux/usersReduce";
import { toast, ToastContainer } from "react-toastify";
import MaterialReactTable from 'material-react-table';
import { useHistory } from "react-router";
import { useTranslation } from 'react-multi-lang'
import { MRT_Localization_FR } from "material-react-table/locales/fr";
import { MRT_Localization_EN } from "material-react-table/locales/en";

// core components
function ListStatus({client}) {
  let lang = window.localStorage.getItem("lang");
  const dispatch = useDispatch();
  const navigate = useHistory();
  const t = useTranslation();
  const [alert, setAlert] = React.useState(null);
  const [entities, setEntities] = React.useState([]);
  const [loader, setLoader] = React.useState(true);

  function changeEtat(id,e) {
    dispatch(statusChangerEtat( id )).then(e1=>{
      getStatus();
      switch(e){
        case 0: notify(1, "activé avec succés");break; 
        case 1:notify(1, "Désactivé avec succés");break;
        default:break;
      }  
    }); 
  }

  const columns = useMemo(
    () => [
      {
        header: t("name"),
        accessorKey: "nom",
      },
      {
        header: t("name") + " En",
        accessorKey: "nom_en",
      },
      {
        accessorKey: 'id',
        header: 'actions',
        Cell: ({ cell, row }) => (
          <div className="actions-right block_action">
            <Button
              onClick={() => {
                navigate.push(client+"/status/update/" + cell.row.original.id);
              }}
              variant="warning"
              size="sm"
              className="text-warning btn-link edit"
            >
              <i className="fa fa-edit" />
            </Button>
            <Button
              id={"idLigne_" + cell.row.original.id}
              onClick={(event) => {
                changeEtat(cell.row.original.id, cell.row.original.etat);
              }}
              variant="danger"
              size="sm"
              className={cell.row.original.etat === 1 ? "text-success btn-link delete" : "text-danger btn-link delete"}
            >
              <i className={cell.row.original.etat === 1 ? "fa fa-check" : "fa fa-times"} id={"idLigne_" + cell.row.original.id} />
            </Button>
          </div>
        ),
      },
      //end
    ],
    [],
  );
  const notify = (status, msg) => {
    if (status === 1)
      toast.success(
        <strong>

          {msg}
        </strong>
      );
    else
      toast.error(
        <strong>

          {msg}
        </strong>
      );
  };
  const confirmMessage = (id, e) => {
    setAlert(
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        title={"Êtes-vous sûr de vouloir supprimer ce rôle ?"}
        onConfirm={() => deleteStatus(id, e)}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="info"
        cancelBtnBsStyle="danger"
        confirmBtnText="Oui"
        cancelBtnText="Non"
        showCancel
      >
        {/* Êtes-vous sûr de supprimer cette User? */}
      </SweetAlert>
    );
  };
  const hideAlert = () => {
    setAlert(null);
  };
  function ajouter() {
    navigate.push(client+"/ajouterStatus");
  }
  function deleteStatus(id, e) {
    dispatch(statusDeleted({ id })).then((val) => {
      notify(1, t("status_supprimer_succes"));
      getStatus();
      hideAlert();
    });
  }

  const getStatus = useCallback(
    async () => {
      var root = await dispatch(fetchStatus());
      setEntities(root.payload);
      setLoader(false)
    },
    [dispatch]
  );

  const verifToken = useCallback(async () => {
    try {
      dispatch(verification()).then(e => {
        if (e.payload === false) {
          localStorage.clear();
          window.location.replace("/login");
        }
      })
    } catch (error) {
      localStorage.clear();
      window.location.replace("/login");
    }

  }, [dispatch]);

  useEffect(() => {
    verifToken()
    getStatus();
  }, [getStatus]); //now shut up eslint

  return (
    <>
      {alert}
      <Container fluid>
        <ToastContainer />
        <Row>
          <Col md="12">
            <Button
              id="saveBL"
              className="btn-wd btn-info mr-1 float-left"
              status="button"
              onClick={ajouter}
            >
              <span className="btn-label">
                <i className="fas fa-plus"></i>
              </span>
              {t("Status.add")}
            </Button>
          </Col>

          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4">{t("Status.list")}</Card.Title>
              </Card.Header>
              <Card.Body className="padding-0">
                <MaterialReactTable
                  state={{ isLoading: loader }}
                  columns={columns}
                  data={entities}
                  enableColumnActions={true}
                  enableColumnFilters={true}
                  enablePagination={true}
                  enableSorting={true}
                  enableBottomToolbar={true}
                  enableTopToolbar={true}
                  muiTableBodyRowProps={{ hover: false }}
                  displayColumnDefOptions={{
                    'mrt-row-numbers': {
                      size: 10,
                    },
                    'mrt-row-expand': {
                      size: 10,
                    },
                  }}
                  enableColumnFilterModes
                  initialState={{
                    columnVisibility: { description: false },
                    density: 'compact',
                    showGlobalFilter: true,
                    sorting: [{ id: 'tableInstanceAPI', desc: false }],
                  }}
                  muiSearchTextFieldProps={{
                    placeholder: t("search"),
                    sx: { minWidth: '18rem' },
                    variant: 'outlined',
                  }}


                  filterFns={{
                    myCustomFilterFn: (row, id, filterValue) => {
                      const value = row.getValue(id);
                      return typeof value === 'string' && value.toLowerCase().includes(filterValue.toLowerCase());
                    },
                  }}
                  globalFilterFn="myCustomFilterFn"

                  localization={
                    lang === "fr"
                      ? MRT_Localization_FR
                      : MRT_Localization_EN
                  }
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ListStatus;
